<div class="auth-wrapper auth-v2">
<div class="auth-inner row m-0">
	<!-- Brand logo--><a class="brand-logo" [routerLink]="['/home']">
	<img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" style="width: 220px; height: 40px;" />
		<h2 class="brand-text text-primary ml-1">MNRE R & D Portal</h2>
	</a>
	<!-- /Brand logo-->
	<!-- Left Text-->
	<div class="d-none d-lg-flex col-lg-7 align-items-center p-5">
	<div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
		<img class="img-fluid" [src]="
			coreConfig.layout.skin === 'dark'
			? 'assets/images/pages/register-v2-dark.svg'
			: 'assets/images/pages/register-v2.svg'
		" alt="Register V2" />
	</div>
	</div>
	<!-- /Left Text-->
	<!-- Register-->
	<div class="d-flex col-lg-5 align-items-center auth-bg px-2 p-lg-5">
	<div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
		<h2 class="card-title font-weight-bold mb-1">User Registration</h2>
		<p class="card-text mb-2"></p>
		<form [formGroup]="accountDetailsForm" autocomplete="off">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label class="form-label" for="firstName">First Name</label>
					<span class="required-asterisk">*</span>
					<input formControlName="FirstName" type="text" name="firstName" id="firstName" class="form-control"
					[ngClass]="{ 'is-invalid': submitted && a.FirstName.errors }"
					placeholder="John" />
					<div *ngIf="submitted && a.FirstName.invalid" class="invalid-form">
					<div *ngIf="a.FirstName.errors.required">This field is required!</div>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label class="form-label" for="lastName">Last Name</label>
					<span class="required-asterisk">*</span>
					<input formControlName="LastName" type="text" name="lastName" id="lastName" class="form-control"
					[ngClass]="{ 'is-invalid': submitted && a.LastName.errors }"
					placeholder="Doe" />
					<div *ngIf="submitted && a.LastName.invalid" class="invalid-form">
					<div *ngIf="a.LastName.errors.required">This field is required!</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
				<label class="form-label" for="email">Email</label>
				<span class="required-asterisk">*</span>
				<input formControlName="Email" email type="text" name="email" id="email" class="form-control"
					[ngClass]="{ 'is-invalid': submitted && a.Email.errors }"
					placeholder="john.doe@email.com" aria-label="john.doe" />
				<div *ngIf="submitted && a.Email.invalid" class="invalid-form">
					<div *ngIf="a.Email.errors.required">This field is required!</div>
				</div>
				</div>
				<div class="form-group">
				<label class="form-label" for="mobile">Mobile</label>
				<span class="required-asterisk">*</span>
				<input formControlName="Mobile" type="text" name="mobile" id="mobile" class="form-control"
					[ngClass]="{ 'is-invalid': submitted && a.Mobile.errors }"
					placeholder="0000000000" maxlength="10"
					[mask]="'^([1-9]\\d*|0)$'" />
				<div *ngIf="submitted && a.Mobile.invalid" class="invalid-form">
					<div *ngIf="a.Mobile.errors.required">This field is required!</div>
				</div>
				</div>
				<div class="form-group">
					<label for="password" class="form-label">Password<span class="required-asterisk">*</span></label>
					<div class="input-group input-group-merge form-password-toggle">
						<input formControlName="Password" [type]="passwordTextType ? 'text' : 'password'" name="password"
						class="form-control form-control-merge" id="password" 
						[ngClass]="{ 'is-invalid error': submitted && a.Password.errors }"
						placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" minlength="6"
						pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" />
						<div class="input-group-append">
						<span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
								'icon-eye-off': passwordTextType,
								'icon-eye': !passwordTextType
							}" (click)="togglePasswordTextType()"></i></span>
						</div>
					</div>
					<sup>The password must contain minimum 8 characters with at least one number, one uppercase and one lowercase letter.</sup>
					<div *ngIf="submitted && a.Password.invalid" class="form-text text-danger invalid-form">
						<div *ngIf="a.Password.errors.required">This field is required!</div>
						<div *ngIf="a.Password.errors.pattern">The password must contain minimum 8 characters with at least one number, one uppercase and one lowercase letter.</div>
					</div>
				</div>
				<div class="form-group">
				<label for="confirmPassword" class="form-label">Confirm Password<span class="required-asterisk">*</span></label>
				<div class="input-group input-group-merge form-password-toggle">
					<input formControlName="ConfirmPassword" [type]="passwordTextType ? 'text' : 'password'"
					name="confirm-password" id="confirm-password" class="form-control"
					[ngClass]="{ 'is-invalid error': submitted && a.ConfirmPassword.errors }"
					placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
					pattern="{{ a.Password.value }}" minlength="6" />
					<div class="input-group-append">
					<span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
							'icon-eye-off': passwordTextType,
							'icon-eye': !passwordTextType
						}" (click)="togglePasswordTextType()"></i></span>
					</div>
				</div>
				<div *ngIf="submitted && a.ConfirmPassword.invalid" class="form-text text-danger invalid-form">
					<div *ngIf="a.ConfirmPassword.errors.required">This field is required!</div>
					<div *ngIf="a.ConfirmPassword.errors.pattern">Password & Confirm Password does not match.</div>
				</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<label class="form-label" for="SubjectArea">Subject Area</label>
					<div class="demo-inline-spacing" 
					style="margin-top: -15px;">
					<div class="custom-control custom-checkbox">
						<input type="checkbox" id="SubjectArea6" formControlName="SubjectArea" name="SubjectArea"
						class="custom-control-input" [value]="10014" (change)="onCheckboxChange($event)" />
						<label class="custom-control-label" for="SubjectArea6">Waste to Hydrogen</label>
					</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-group">
			<div class="custom-control custom-checkbox">
			<input class="custom-control-input" type="checkbox" id="register-privacy-policy" tabindex="4" formControlName="privacyPolicy" [ngClass]="{ 'is-invalid': submitted && a.privacyPolicy.errors }"/>
			<label class="custom-control-label" for="register-privacy-policy">
				I agree to privacy policy & terms
			</label>
			
			</div>
		</div>
		<button class="btn btn-primary btn-block" *ngIf="this.signupVisible" tabindex="5" (click)="onSubmit()" rippleEffect>Sign up</button>
		</form>
		<p class="text-center mt-2">
		<span>Already have an account?</span><a routerLink="/login"><span>&nbsp;Sign in
			instead</span></a>
		</p>
		<div class="divider my-2">
		<div class="divider-text">or</div>
		</div>
		<div class="auth-footer-btn d-flex justify-content-center">
		<a class="btn btn-facebook" href="javascript:void(0)"><i data-feather="facebook"></i></a><a
			class="btn btn-twitter white" href="javascript:void(0)"><i data-feather="twitter"></i></a><a
			class="btn btn-google" href="javascript:void(0)"><i data-feather="mail"></i></a><a class="btn btn-github"
			href="javascript:void(0)"><i data-feather="github"></i></a>
		</div>
	</div>
	</div>
	<!-- /Register-->
</div>
</div>